module.exports = __webpack_public_path__ + "static/media/rabbitohs-silhouette.7ce9240f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/teamSilhouettes/rabbitohs-silhouette.svg
// module id = 1331
// module chunks = 0